import { string, bool } from 'prop-types';

import { NoData, NoSearchResults } from '../shared/TerritoryTable.style';
import salesTypes from 'maps/sales-types';
import entityProptypes from 'propTypes/entityTypes';
import salesProptypes from 'propTypes/salesTypes';

function NoResults(props) {
  const { entityType, searchValue, isLargeScreen, selectedSalesType } = props;

  if (searchValue.length > 0) {
    return (
      <NoSearchResults>
        No search results for <span>‘{searchValue}’.</span>
      </NoSearchResults>
    );
  }
  return (
    <NoData isSmallScreen={!isLargeScreen}>
      <p>
        Unfortunately there is no{' '}
        {salesTypes[selectedSalesType].label.toLowerCase()} data available for
        this {entityType}.
      </p>
    </NoData>
  );
}

NoResults.propTypes = {
  entityType: entityProptypes.isRequired,
  searchValue: string,
  isLargeScreen: bool.isRequired,
  selectedSalesType: salesProptypes.isRequired,
};

export default NoResults;
